// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;   /* buttons ke beech space */
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Roles/EditRole/EditRole.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS,IAAI,2BAA2B;EACxC,gBAAgB;AAClB","sourcesContent":[".form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;   /* buttons ke beech space */\n  margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
